export enum PaymentType {
  COINS = "Coins",
  CASH = "Cash",
  CREDIT_CARD = "Credit Card",
  DEBIT_CARD = "Debit Card",
  APPLE_PAY = "Apple Pay",
  GOOGLE_PAY = "Google Pay",
}
